import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Table,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { CSVExport } from "react-bootstrap-table2-toolkit"

// import Multiselect from "multiselect-react-dropdown"

//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as sourceAction from "../../store/c291cmNlUmVwb3J0/actions"
import ButtonSpinner from "../../components/ButtonSpinner"

const SourceReport = (props) => {
  const { dispatch, searchBarStyle } = props
  const title = "Source Report"

  //Search bar and validations
  const { SearchBar } = Search
  const specificDispatch = useDispatch()

  useEffect(() => {
    dispatch(sourceAction.loadRecordsMetaData())
    dispatch(sourceAction.loadSourceReportList())
  }, [])

  const sourceUpdate = useSelector((state) => state.sourceReport)
  console.log(sourceUpdate, "sourceUpdate")

  const { sourceMetaData = {}, source_report = [] } = sourceUpdate
  console.log(sourceMetaData, "sourceMetaData")
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  //Offer initial state
  const [sourceData, setSourceData] = useState({
    company: [],
    branch: [],
    event: [],
    fromDate: "",
    toDate: "",
  })

  //Handle change

  const handleChange = async (e) => {
    setSourceData({ ...sourceData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [source, setCource] = useState([])

  //Source Count Modal Dropdown
  const [companyList, setCompany] = useState([])
  const [branchList, setBranch] = useState([])
  const handleCompanyChange = (e) => {
    setCompany(e)
    setBranch([])
  }

  //Modal View
  const [sourceCountView, setSourceCountView] = useState(false)
  const [countLoader, setCountLoader] = useState(false)
  const handleFollowupClose = () => setSourceCountView(false)

  const handleCompanyClose = () => setCompanyView(false)
  const [companyView, setCompanyView] = useState(false)
  const [sourceView, setSourceView] = useState(false)
  const [sourceCountDetails, setSourceCountDetails] = useState("")
  const [companyDetails, setCompanyDetails] = useState("")

  const [filterDetails, setFilterDetails] = useState({
    companyId: "",
    branchId: "",
  })
  //Source Count details
  const sourceCountFilter = (e) => {
    e.preventDefault()
    const companyId = companyList.value
    const branchId = branchList.value
    setCountLoader(true)
    setFilterDetails({
      ...filterDetails,
      companyId: companyId,
      branchId: branchId,
    })
    setSourceView(false)
    setTimeout(() => {
      setCountLoader(false)
    }, 2000)
    console.log(companyId, branchId, "count details")
  }

  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setSourceData({
      fromDate: "",
      toDate: "",
    })
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  //dropdown options

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const branchOptions =
    !isEmpty(sourceMetaData) &&
    sourceMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )
  const branchListOptions =
    !isEmpty(sourceMetaData) &&
    sourceMetaData.branchOptions.filter(
      (branch) => branch.companyId === companyList.value
    )

  //Apply filter submit

  const applyFilter = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchSource = source && source.value ? source.value : ""

    var searchFromDate =
      sourceData && sourceData.fromDate
        ? moment(sourceData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      sourceData && sourceData.toDate
        ? moment(sourceData.toDate).format("YYYY-MM-DD")
        : ""

    var searchValue = {}
    if (searchCompany) {
      searchValue.companyId = searchCompany
    }

    if (searchBranch) {
      searchValue.branchId = searchBranch
    }
    if (searchSource) {
      searchValue.sourceId = searchSource
    }

    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.toDate = searchToDate
    }
    console.log("filter values", applyFilter)
    specificDispatch(sourceAction.loadSourceReportList(searchValue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  //Data table for Offer
  console.log(sourceCountDetails, "sourceCountDetails")

  const sourceViewDetails = () => {
    setSourceCountView(true)
    setSourceView(true)
    setCompany([])
    setBranch([])
  }

  let sNo = 0
  let slNo = 0
  const offerReportTable = !isEmpty(source_report)
    ? source_report.map((sourceData, index) => {
        slNo = slNo + 1
        return {
          _id: sourceData._id,
          sNo: slNo,
          subSource: (
            <i
              className="fa fa-arrow-down mx-3"
              style={{ color: "#e40d8c" }}
              aria-hidden="true"
            ></i>
          ),
          leadNo: sourceData.leadNo,
          branchId: sourceData.branchId,
          subSources: sourceData.subSources,
          branchName: sourceData.branchName,
          leadSubSourceDetails: sourceData.leadDetailsSubSourceDetails,
          leadSourceCount: (
            <div className="d-flex flex-row">
              <p style={{ fontSize: "12px", marginTop: "6px" }}>
                {!isEmpty(sourceData.leadDetail)
                  ? sourceData.leadDetail.length
                  : "--"}
              </p>
              <i
                className="fas fa-eye icon-btn mx-3"
                style={{ fontSize: "16px", color: "#3498db", marginTop: "6px" }}
                onClick={() => {
                  sourceViewDetails()
                  setSourceCountDetails(sourceData.leadDetail)
                }}
              ></i>
            </div>
          ),
          clientName: !isEmpty(sourceData.clientDetails)
            ? sourceData.clientDetails.firstName +
              " " +
              sourceData.clientDetails.lastName
            : "",
          companyId: sourceData.companyId,
          companyName: (
            <Button
              className="btn btn-success"
              onClick={() => {
                setCompanyDetails(sourceData.companyDetails)
                setCompanyView(true)
              }}
            >
              View
            </Button>
          ),
          leadServiceName: sourceData.leadServiceName,
          sourceName: sourceData.sourceName,
          company: sourceData.companyName,
          comapnyDetails: sourceData.companyDetails,
          key: index,
        }
      })
    : []

  //download feature in data table
  const { ExportCSVButton } = CSVExport

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Lead No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Source Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                {/* {row.companyName} */}
                Company Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                {/* {row.companyName} */}
                Branch Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                {/* {row.companyName} */}
                Sales Agent
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.leadSubSourceDetails.length > 0 ? (
              row.leadSubSourceDetails.map((data) => {
                console.log(data, "row list data")
                return (
                  <tr key={data.id}>
                    <th>{data.leadNo}</th>
                    <th>{data.leadSubSourceName}</th>
                    <td>{data.companyName}</td>
                    <td>{data.branchName}</td>
                    <td>{data.salesAgent}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    // showExpandColumn: true,
    // expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  //columns for data table
  const columns = [
    // {
    //   dataField: "_id",
    //   text: "id",
    //   hidden: dropdownSelect ? false : true,
    //   headerStyle: {
    //     minWidth: "160px",
    //   },
    // },
    {
      dataField: "sNo",
      text: "S.No",
      // expandRow: false,
    },
    {
      dataField: "sourceName",
      text: "Source Name",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
      // expandRow: false,
    },
    {
      dataField: "subSource",
      text: "Sub Source",
      headerStyle: {
        minWidth: "140px",
      },
      // expandRow: true,
    },
    {
      dataField: "leadSourceCount",
      text: "Lead Source Count",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "148px",
      },
    },
  ]

  // pagination options
  const options = {
    sizePerPage: 50,
    totalSize: source_report.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Reports"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            sourceMetaData ? sourceMetaData.companyOptions : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Source"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="source"
                          value={source}
                          onChange={(e) => setCource(e)}
                          options={
                            sourceMetaData ? sourceMetaData.sourceOptions : []
                          }
                          placeholder="Select Source"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={sourceData.fromDate}
                          max={sourceData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={sourceData.toDate}
                          min={sourceData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="button"
                            onClick={() => applyFilter()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(options)}
                    keyField="_id"
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={offerReportTable}
                        columns={columns}
                        search
                        exportCSV
                      >
                        {(props) => (
                          <div>
                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                              <Row className="d-flex flex-row">
                                <Col className="mb-3" md="4">
                                  <div className="d-flex flex-row ">
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                      <div
                                        className="position-relative mt-7"
                                        style={searchBarStyle || null}
                                      >
                                        <SearchBar {...props.searchProps} />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </div>{" "}
                                </Col>

                                <Col>
                                  <ExportCSVButton
                                    className="border float-right mx-10"
                                    style={{
                                      float: "right",
                                      backgroundColor: "#e40d8c",
                                      color: "#ffffff",
                                    }}
                                    {...props.csvProps}
                                  >
                                    Download{" "}
                                  </ExportCSVButton>{" "}
                                  {/* <Col className="bootstrap-table-filter">
                                    <div style={{ marginRight: "20px" }}>
                                      <Multiselect
                                        options={columns
                                          .filter((_) => _.hidden)
                                          .map((el) =>
                                            Object.assign(
                                              {},
                                              {
                                                label: el.text,
                                                value: el.dataField,
                                              }
                                            )
                                          )}
                                        selectedValues={tableFilterOpt}
                                        onSelect={(selVal) => {
                                          // columns
                                          //   .filter((_) => _.hidden)
                                          //   .map((el) => {

                                          setTableFilterOpt(selVal)
                                          // if (
                                          //   selVal &&
                                          //   selVal.map(
                                          //     (val) => val.value
                                          //   ) === el.dataField
                                          // ) {
                                          setDropdownSelect(true)
                                          // }
                                        }}
                                        onRemove={(remVal) => {
                                          setTableFilterOpt(remVal)
                                        }}
                                        displayValue="label"
                                        showCheckbox
                                        placeholder={
                                          tableFilterOpt &&
                                          tableFilterOpt.length > 0
                                            ? `${tableFilterOpt.length} Item${
                                                tableFilterOpt.length > 1
                                                  ? "s"
                                                  : ""
                                              } Selected`
                                            : "Select Column"
                                        }
                                      />
                                    </div>
                                  </Col> */}
                                </Col>
                                <Col md="12" xl="12" lg="12" xs="12" sm="12">
                                  <BootstrapTable
                                    {...props.baseProps}
                                    responsive
                                    striped={true}
                                    bordered={true}
                                    keyField="_id"
                                    columns={columns}
                                    expandRow={expandRow}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                              <Row
                                style={{ marginTop: "5px" }}
                                className="align-items-md-center mt-30"
                              >
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline d-flex flex-row">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "8px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      <PaginationTotalStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="text-md-right ms-auto"
                                    style={{ zIndex: 0 }}
                                  >
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {sourceCountView && (
          <Modal show={sourceCountView} size="lg" onHide={handleFollowupClose}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Source Count Details</span>
              </div>
            </Modal.Header>
            <Modal.Body className="h-70">
              <Col>
                <Row className="mb-5">
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"} htmlFor={"Company"}>
                        {"Company"}
                      </Label>
                    </div>
                    <Select
                      type="text"
                      name="companyList"
                      value={companyList}
                      onChange={(e) => handleCompanyChange(e)}
                      options={
                        sourceMetaData ? sourceMetaData.companyOptions : []
                      }
                      placeholder="Select Company"
                      classNamePrefix="select2-selection"
                      zIndex="2"
                    />
                  </Col>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"} htmlFor={"Branch"}>
                        {"Branch"}
                      </Label>
                    </div>
                    <Select
                      type="text"
                      name="branchList"
                      value={branchList}
                      onChange={(e) => setBranch(e)}
                      options={branchListOptions}
                      placeholder="Select Branch"
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                  <Col
                    lg="3"
                    md="3"
                    sm="3"
                    xs="3"
                    style={{ marginTop: "40px" }}
                  >
                    <Button
                      type="submit"
                      onClick={(e) => {
                        sourceCountFilter(e)
                      }}
                      className="btn btn-success mx-2"
                    >
                      {" "}
                      {countLoader && countLoader ? (
                        <ButtonSpinner />
                      ) : (
                        <i className="bx bx-search-alt search-icon mt-1" />
                      )}{" "}
                    </Button>
                  </Col>
                </Row>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "20px" }}>S.No</th>
                          <th style={{ minWidth: "110px" }}>Lead No</th>
                          <th style={{ minWidth: "109px" }}>Company</th>
                          <th style={{ minWidth: "110px" }}>Branch</th>
                          <th style={{ minWidth: "110px" }}>Source Name</th>
                          <th style={{ minWidth: "110px" }}>Source Date</th>
                          <th style={{ minWidth: "60px" }}>Remarks</th>
                          <th style={{ minWidth: "110px" }}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isEmpty(sourceCountDetails) ? (
                          sourceCountDetails.map((source) => {
                            // const dateFormate =
                            // !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
                            const sourceDate = !isEmpty(source.leadDate)
                              ? moment(source.leadDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format(dateFormate)
                              : []
                            const colorCode =
                              !isEmpty(sourceMetaData) &&
                              sourceMetaData.processStatusOptions &&
                              sourceMetaData.processStatusOptions.length > 0 &&
                              sourceMetaData.processStatusOptions.find(
                                (_) =>
                                  _.processStatusId === source.processStatus
                              ) &&
                              sourceMetaData.processStatusOptions.find(
                                (_) =>
                                  _.processStatusId === source.processStatus
                              ).colorCode
                            if (
                              filterDetails.companyId === source.companyId &&
                              filterDetails.branchId === source.branchId
                            ) {
                              sNo = sNo + 1
                              return (
                                <tr key={source._id}>
                                  <td>{sNo}</td>
                                  <td style={{ color: "#E40D8C" }}>
                                    {source.leadNo}
                                  </td>
                                  <td>{source.companyName}</td>
                                  <td>{source.branchName}</td>
                                  <td>{source.leadSourceName}</td>
                                  <td>{sourceDate}</td>
                                  <td>{source.remarks}</td>
                                  <td>
                                    <button
                                      style={{
                                        background: colorCode,
                                        border: "none",
                                        cursor: "pointer",
                                        color: "white",
                                        padding: "2px",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {source.processStatusName}
                                    </button>
                                  </td>
                                </tr>
                              )
                            } else if (sourceView === true) {
                              sNo = sNo + 1
                              return (
                                <tr key={source._id}>
                                  <td>{sNo}</td>
                                  <td style={{ color: "#E40D8C" }}>
                                    {source.leadNo}
                                  </td>
                                  <td>{source.companyName}</td>
                                  <td>{source.branchName}</td>
                                  <td>{source.leadSourceName}</td>
                                  <td>{sourceDate}</td>
                                  <td>{source.remarks}</td>
                                  <td>
                                    <button
                                      style={{
                                        background: colorCode,
                                        border: "none",
                                        cursor: "pointer",
                                        color: "white",
                                        padding: "2px",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {source.processStatusName}
                                    </button>
                                  </td>
                                </tr>
                              )
                            }
                          })
                        ) : (
                          <tr key={0}>
                            <td className="text-align-center" colSpan={5}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                onClick={() => {
                  // deleteNightshift()
                  setSourceView(true)
                  setSourceCountView(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {companyView && (
          <Modal show={companyView} size="lg" onHide={handleCompanyClose}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>Company Details</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Company Name</th>
                          <th>Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isEmpty(companyDetails)
                          ? Object.entries(companyDetails).map(
                              ([key, value]) => {
                                return (
                                  <tr key={key}>
                                    <td style={{ minWidtd: "110px" }}>{key}</td>
                                    <td>{value}</td>
                                  </tr>
                                )
                              }
                            )
                          : []}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                onClick={() => {
                  // deleteNightshift()
                  setCompanyView(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </React.Fragment>
  )
}

SourceReport.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SourceReport)
)
